import { Component, OnInit, AfterViewInit, EventEmitter } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { LOCAL_VAR, matchValidation } from '@app/core';
import { environment } from '../../../environments/environment';
import { ToastrService } from 'ngx-toastr';
import { finalize } from 'rxjs/operators';
import { AuthenticationService } from '@app/core/authentication/authentication.service';

@Component({
  selector: 'app-verification',
  templateUrl: './verification.component.html',
  styleUrls: ['./verification.component.scss']
})
export class VerificationComponent implements OnInit, AfterViewInit {
  isLoading = true;
  queryParams: any;
  status = 0;
  error: any;
  message = ''
  applogo=environment.logo;
  logo=environment.logo;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private toastrService: ToastrService,
    private authenticationService: AuthenticationService,
  ) {
    this.isLoading = true;
  //  this.route.queryParams.subscribe(param => {});
    this.route.queryParams.pipe().subscribe(params => {
      this.queryParams = params;
      //console.log(this.queryParams.savi, 'this.queryParams');
      
    });
    var domainconfig = JSON.parse(localStorage.getItem(LOCAL_VAR.domainconfig));
    this.applogo = "assets/images/dowc-logo-green-bg.jpg";
    this.logo = "assets/images/dowc-logo.png";
    if (domainconfig) {
      if (domainconfig.appLogo) {
        this.applogo = domainconfig.appLogo;
      }
      if (domainconfig.appLogo) {
        this.logo = domainconfig.appLogo;
      }
    }
  }
  ngOnInit() {
    this.verifyemail();
  }

  ngAfterViewInit() {}

  verifyemail() {
    const payload = {
      activationCode: this.queryParams.savi
    };
    this.authenticationService
      .verifyemail(payload) 
      .pipe(
        finalize(() => {
          this.isLoading = false;   
        })
      )
      .subscribe((response: any) => {
        this.isLoading = false;
        this.status = 1;
      },
        (error: any) => {
          this.isLoading = false;
          this.status = 2;
          if (error.error){
            this.message = error.error.message;
          } else {
            this.message = 'Sorry! Unable to proceed your request';
          }
      });
  } 
}
